(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var heroes = document.querySelectorAll('[data-rs-hero]');
    if (!heroes.length) return;

    var speed = 0.2;
    var maxBlur = 28;
    var lastY = window.scrollY;
    var current = 0;
    var raf = null;

    function paint() {
      var y = window.scrollY;
      var delta = Math.abs(y - lastY);
      lastY = y;
      current = Math.max(Math.min(delta, maxBlur), current * 0.85);
      if (current < 0.05) current = 0;

      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        hero.style.setProperty('--rs-hero-shift', (rect.top * speed).toFixed(2) + 'px');
        hero.style.setProperty('--rs-hero-blur', current.toFixed(2) + 'px');
        hero.style.setProperty('--rs-hero-glow', (current / maxBlur).toFixed(3));
      });

      raf = current > 0 ? window.requestAnimationFrame(paint) : null;
    }

    function onScroll() {
      if (raf === null) raf = window.requestAnimationFrame(paint);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paint();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-services"] && !Shopify.designMode) return;
  try {
    
  class RsServicesIndex extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.slides.length) return;
      this.querySelectorAll('[data-index]').forEach((row) => {
        const show = () => this.show(row.dataset.index);
        row.addEventListener('pointerenter', show);
        row.addEventListener('focus', show);
      });
    }

    show(index) {
      this.slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.slide === index));
    }
  }

  customElements.define('rs-services-index', RsServicesIndex);

  } catch(e) { console.error(e); }
})();
})();
